<template>
  <section
    class="grid grid-cols-4 md:grid-cols-8 xl:grid-cols-12 gap-x-4 xl:gap-x-6 md:px-5 px-2 text-skin-secondary"
  >
    <section
      class="col-start-1 col-end-9 row-start-1 row-end-2 pt-12 px-4 xl:px-9 mb-4"
    >
      <p class="text-xl opacity-50 mb-3" v-text="'Acceder a Mentorías'" />
      <p class="text-lg" v-text="valid ? nameCourse : 'CURSO NO VALIDO'" />

      <p class="text-sm" v-text="`Responsable: ${ownerCourse}`" v-if="ownerCourse" />

      <div class="md:flex w-full">

        <section
          v-if="valid"
          class="w-full md:w-4/12 px-4 xl:px-9"
        >
          <p
            class="text-sm opacity-50 mt-6 mb-2"
            v-text="'Dias disponibles'"
          />

          <section class="border border-black rounded-2xl py-6 pl-6 pr-3">

            <p
              class="text-sm opacity-50 mb-2"
              v-text="'Busca un dia'"
            />

            <input type="date" class="w-full mb-2 bg-transparent focus:outline-none" 
            v-if="render"
            v-model="filterDay" placeholder="dd/mm/aaaa">

            <section class="pr-3 overflow-y-auto light-scroll h-32 md:h-80"> 
              <button v-for="(item, index) in days" :key="index" 
              class="border rounded-2xl py-2 px-4 mb-2 transition-all w-full
              hover:bg-skin-pink hover:text-white transition duration-400 focus:outline-none"
              :class="[
                activeDay==item.date ? 'bg-skin-pink text-white border-secondary' : 'border-black'
              ]"
              @click="selectDay(item.date)">
                {{item.date}}
              </button>
              <p v-if="days.length==0" class="text-sm opacity-60 text-justify">Lo sentimos, no existen dias en los que puedas solicitar mentorias. Puede que necesites esperar respuestas de las solicitudes que has hecho o avanzar un poco más en el curso</p>
            </section>


          </section>
        </section>
        <section class="w-full md:w-8/12 px-4 xl:px-9">
          <p
            class="text-sm opacity-50 mt-6 mb-2"
            v-text="'Horario disponibles'"
          />
          <section class="border border-black rounded-2xl py-6 pl-6 pr-3" v-if="!loadingRequest">
            <section class="pr-3 h-24 md:h-96 overflow-y-auto light-scroll"
              :class="[schedule.length==0 ? 'flex justify-center items-center' : '']"
            > 

              <postulation-card v-for="(item, index) in schedule" :key="index" 
                :schedule="item" 
                @requestMentory="requestMentory"
              />

              <p v-if="schedule.length==0" class="text-lg"> Por favor selecciona un dia</p>

            </section>
          </section>

          <section class="border border-black rounded-2xl py-6 pl-6 pr-3" v-if="loadingRequest">
            <div class="first:border-transparent border-t border-black pl-1 text-sm">
              <div class="w-full rounded-md shadow-selectable pt-4 lg:py-4">
                  <div class="animate-pulse flex">
                      <div class="w-6/12 flex">
                          <div class="w-32 h-5 border rounded bg-gray-200 "></div>
                      </div>
                      <div class="w-6/12 flex justify-end">
                          <div class="w-32 h-8 border rounded-full bg-gray-200 "></div>
                      </div>
                  </div>
              </div>
            </div>
          </section>
        </section>


      </div>
    </section>

    <section
      v-if="valid"
      class="col-start-1 col-end-9 xl:col-start-9 xl:col-end-13 row-start-2 xl:row-start-1 row-end-3 xl:pt-12 pb-7 xl:pb-6 px-4 xl:pl-0 xl:pr-8 px-4 xl:px-9"
    >
      <section class="flex w-full bg-skin-pink mb-2 rounded-lg p-1 text-white">
        <button @click="typeActive=0" class="mx-1 p-2 text-center w-6/12 focus:outline-none hover:text-skin-secondary hover:bg-skin-primary transition duration-400 rounded-lg" v-text="'Solicitudes pendientes'" 
        :class="[typeActive==0 ? 'text-skin-secondary bg-skin-primary' : '']"
        /> 
        <button @click="typeActive=1" class="mx-1 p-2 text-center w-6/12 focus:outline-none hover:text-skin-secondary hover:bg-skin-primary transition duration-400 rounded-lg" 
        :class="[typeActive==1 ? 'text-skin-secondary bg-skin-primary' : '']" v-text="'Solicitudes Activas '" /> 

      </section>
      <section class="border border-black rounded-2xl py-6 pl-6 pr-3 bg-blueSalude bg-opacity-30">
        <section class="pr-3 h-32 md:h-120 overflow-y-auto light-scroll">
        <historical-mentory-card :mentory="mentory" :typeActive="typeActive"
          class="mb-4 mx-2"
          v-for="(mentory, index) in mentoryUser"
          :key="index"
        />
        </section>
      </section>
    </section>
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { STORE_NAME_COURSES } from "../store/modules/courses/";
import { STORE_NAME_MENTORIES } from "../store/modules/mentories/";
import utilsMixin from "../mixins/utilsMixin";
import HistoricalMentoryCard from "../components/HistoricalMentoryCard.vue"
import toastr from "toastr";
export default {
  mixins: [utilsMixin],
  components: {
    PostulationCard: () => import("../components/PostulationCard.vue"),
    HistoricalMentoryCard,
  },
  data: () => ({
    owner: {
      id: null,
      name: null,
    },
    daysToSet: {},
    mentoryFilter: "historic",
    stylesCalendar: {
      disabled: {
        selectable: true,
        class: "",
      },
      reserved: {
        selectable: true,
        class: "rouded-full bg-skin-pink text-white select-reserved",
      },
    },
    windowWidth: window.innerWidth,
    currentDate: '',
    cantUser: null,
    valid:true,
    activeDay:null,
    filterDay:'',
    render:true,
    typeActive:0,
  }),
  mounted() {
    this.getCoursesByUser({_id : this.$route.params.id});
    this.getMentoryUser({_id : this.$route.params.id});

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  computed: {
    ...mapGetters("getUser", ["GET_USER"]),
    ...mapGetters(STORE_NAME_COURSES, ["course", "loadingCourse"]),
    ...mapGetters(STORE_NAME_MENTORIES, ["loadingRequest", "mentoryUser"]), 
    nameCourse(){
      if(this.course)
        return this.course.course
      return null
    },
    ownerCourse(){
      if(this.course)
        return this.course.owner
      return null
    },
    days(){
      if(this.course){
        const day = []
        if(this.course.days && Object.keys(this.course.days).length > 0){
          for (let key in this.course.days) {
            if(this.filterDay=='' || this.$date(this.filterDay).format("DD/MM/YYYY")==key){
              day.push({
                date:key,
                hours:this.course.days[key],
              })
            }
          }
        }
        return day
      }
      return []
    },

    schedule(){
      if(this.activeDay){
        if(this.days.length > 0){
          const reps = this.days.find(day => day.date == this.activeDay);
          if(reps!=undefined)
            return reps.hours
        }
      }
      return []
    },
    
  },
  methods: {
    ...mapActions(STORE_NAME_COURSES, ["getCoursesByUser", "changeDays"]),
    ...mapActions(STORE_NAME_MENTORIES, ["postRequestMentory", "getMentoryUser"]), 
    onChangeMentoryFilter(_filter) {
      this.mentoryFilter = _filter;
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    selectDay(date){
      this.activeDay = date
    },
    async requestMentory(mentory){
      const resp = await this.postRequestMentory({_body: { mentory_available_id:mentory }})
      if(resp){
        this.changeDays({_days: resp.mentoryAvailables})
        toastr.success("Solicitud creada")
      }
      else
        toastr.error("Surgio un problema!")
    },
  },
  watch:{
    loadingCourse(){
      if(!this.loadingCourse){
        this.valid = Object.keys(this.course).length ? true : false
      }
    },
    filterDay(){
      if(this.filterDay==''){
        this.render = false
        this.$nextTick(() => (this.render = true));
      }
    }
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
};
</script>
